import React from "react";
import {
  HotelSlotProvider,
  useDefaultHotelSlots,
  type HotelSlotType,
} from "./create";

export interface DefaultHotelSlotProviderProps {
  slotOverrides?: Partial<HotelSlotType>;
  children?: React.ReactNode;
}

export const DefaultHotelSlotProvider = ({
  slotOverrides,
  children,
}: DefaultHotelSlotProviderProps) => {
  const defaultSlots = useDefaultHotelSlots();
  const context = React.useMemo(
    () =>
      defaultSlots
        ? {
            components: { ...defaultSlots, ...slotOverrides },
            providerName: "hotels",
          }
        : null,
    [defaultSlots, slotOverrides]
  );
  if (context == null) {
    return null;
  }
  return <HotelSlotProvider context={context}>{children}</HotelSlotProvider>;
};
